module.exports = __webpack_public_path__ + "img/patrtyk.1c9cdf0c.png";